"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _withdrawalAudit = require("@/api/financialManagement/withdrawalAudit");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'WithdrawalAudit',
  data: function data() {
    return {
      queryData: {
        phoneNo: '',
        memberId: '',
        alipayAccountNo: '',
        name: '',
        statusList: '',
        status: '',
        page: 1,
        size: 10
      },
      statusTypeDataIndex: 0,
      statusTypeData: [{
        name: '所有',
        id: ''
      }, {
        name: '待审核',
        id: 1
      }, {
        name: '审核拒绝',
        id: 3
      }, {
        name: '审核通过',
        id: 2
      }],
      total: 0,
      tableData: [
        //   {
        //   withdrawNo: '提现申请编号', //	提现申请编号
        //   memberId: '会员Id', //	会员Id
        //   nickname: '会员昵称', //	会员昵称
        //   alipayAccountNo: '支付宝账号', //	支付宝账号
        //   alipayName: '11支付宝姓名11', //	支付宝姓名
        //   selfOrderCount: '自购订单数', //	自购订单数
        //   amount: '提现金额', //		提现金额
        //   status: '状态', //			状态
        //   withdrawType: '提现类型', //			提现类型
        //   createTime: '提现申请时间', //			提现申请时间
        //   rejectReason: '拒绝原因', //				拒绝原因
        //   auditReason: '审核原因', //					审核原因
        //   errorReason: '异常原因'//					异常原因
        // }
      ],
      loading: false,
      // loading
      dialogVisible: false,
      examineData: {
        memberId: '',
        withdrawFilingId: '',
        status: '',
        remark: ''
      },
      multipleSelection: []
    };
  },
  created: function created() {
    this.listWithdrawFilingPaged();
  },
  methods: {
    onBatchPass: function onBatchPass() {
      var _this = this;
      if (this.multipleSelection.length === 0) {
        this.$notify.error({
          title: '温馨提示',
          message: '请选择需要操作的数据'
        });
        return;
      }
      this.$confirm('确认对当前选中用户备案执行批量通过的操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.batchAuditFiling();
      });
    },
    onStatusList: function onStatusList(data, index) {
      this.statusTypeDataIndex = index;
      this.queryData.status = index === 0 ? '' : data.id;
      this.queryData.page = 1;
      this.queryData.size = 10;
      this.listWithdrawFilingPaged();
    },
    listWithdrawFilingPaged: function () {
      var _listWithdrawFilingPaged2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context.n = 1;
              return (0, _withdrawalAudit.listWithdrawFilingPaged)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                this.tableData = res.data.data;
                this.total = res.data.total;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function listWithdrawFilingPaged() {
        return _listWithdrawFilingPaged2.apply(this, arguments);
      }
      return listWithdrawFilingPaged;
    }(),
    // 审核备案
    auditFiling: function () {
      var _auditFiling2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = (0, _objectSpread2.default)({}, this.examineData);
              _context2.n = 1;
              return (0, _withdrawalAudit.auditFiling)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                console.log('res', res);
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.onClone();
                this.listWithdrawFilingPaged();
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function auditFiling() {
        return _auditFiling2.apply(this, arguments);
      }
      return auditFiling;
    }(),
    onInquire: function onInquire() {
      this.listWithdrawFilingPaged();
    },
    onInitialize: function onInitialize() {
      this.queryData = {
        phoneNo: '',
        memberId: '',
        alipayAccountNo: '',
        name: '',
        statusList: '',
        page: 1,
        size: 10
      };
      this.listWithdrawFilingPaged();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      console.log('val', val);

      // this.multipleSelection = val.map(item => item.memberId)
      this.multipleSelection = val;
    },
    handleClose1: function handleClose1() {
      this.dialogVisible = false;
    },
    onPass: function onPass(data) {
      var _this2 = this;
      this.examineData.memberId = data.memberId;
      this.examineData.withdrawFilingId = data.withdrawFilingId;
      this.examineData.status = 2;
      this.$confirm('是否确认通过审核?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.auditFiling();
      });
    },
    onTurnDown: function onTurnDown(data) {
      this.examineData.withdrawFilingId = data.withdrawFilingId;
      this.examineData.memberId = data.memberId;
      this.examineData.status = 1;
      this.dialogVisible = true;
    },
    examineVerify: function examineVerify() {
      var _this3 = this;
      if (!this.examineData.remark) {
        this.$message({
          message: '请输入拒绝原因',
          type: 'warning'
        });
        return;
      }
      this.$confirm('是否确拒绝通过审核?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.auditFiling();
      });
    },
    onClone: function onClone() {
      this.dialogVisible = false;
      this.examineData = {
        withdrawFilingId: '',
        status: '',
        remark: ''
      };
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.size = val;
      this.listWithdrawFilingPaged();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page = val;
      this.listWithdrawFilingPaged();
    },
    // 用户详情
    onUserDetails: function onUserDetails(value) {
      this.$router.push({
        path: '/member/userDetails',
        query: {
          memberId: value.memberId,
          nickname: value.nickname
        }
      });
    },
    batchAuditFiling: function () {
      var _batchAuditFiling2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = {
                status: 2,
                auditParams: []
              };
              this.multipleSelection.forEach(function (item, index) {
                params.auditParams.push({
                  memberId: item.memberId,
                  withdrawFilingId: item.withdrawFilingId
                });
              });
              _context3.n = 1;
              return (0, _withdrawalAudit.batchAuditFiling)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                console.log('res', res);
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.multipleSelection = [];
                this.listWithdrawFilingPaged();
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function batchAuditFiling() {
        return _batchAuditFiling2.apply(this, arguments);
      }
      return batchAuditFiling;
    }()
  }
};